import React from 'react'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { CiTrash } from 'react-icons/ci'
import { displayImage } from '../../helpers/config'
import FormatCurrency from '../../helpers/FormatCurrency'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../helpers/Axios'

function MiniCartItem({ data = null, ...rest }) {


    const queryClients = useQueryClient()
    // Change Quantity

    const { mutate: change } = useMutation({
        mutationFn: async (formData) => {
            return apiClient.post('/cart/change', formData)
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleQuantityChangle = (id, target) => {
        change({ id, target })
    }



    // Delete Item
    const { mutate: deleteItem } = useMutation({
        mutationFn: async (id) => {
            return apiClient.delete('/cart/delete', { params: { id: id } })
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleDelete = (id) => {
        deleteItem(id)
    }




    return (
        <div className="flex gap-5 relative pb-4 border-b w-full" {...rest}>
            {/* image */}
            <div>
                <img src={displayImage(JSON.parse(data?.product?.images)[0])} alt="" className='w-28 drop-shadow-sm' />
            </div>
            {/* Details */}
            <div className="w-full font-serif space-y-1">
                <h3 className='truncate w-full text-sm'>{data?.product?.name}</h3>
                <p className="text-gray-700 text-sm">
                    <FormatCurrency amount={(data?.variant?.price || data?.price) - data?.discount} />
                </p>
                {data?.product?.customable && (
                    <div className="text-gray-500 text-xs flex gadiv-2">
                        Customization: <FormatCurrency amount={data?.customisation_price} />
                    </div>
                )}

                {/* Quantity */}
                <div className="w-20 rounded p-2 py-1 bg-gray-100 border flex items-center justify-between">
                    <button onClick={() => handleQuantityChangle(data?.id, 'minus')}><AiOutlineMinus size={11} /></button>
                    <input type="text" value={data?.quantity} disabled onChange={() => { }}
                        className='outline-none text-sm bg-transparent w-5 text-center'
                    />
                    <button onClick={() => handleQuantityChangle(data?.id, 'plus')}><AiOutlinePlus size={11} /></button>
                </div>
            </div>

            {/*Delete Trash  */}
            <button onClick={() => handleDelete(data?.id)} className='absolute top-0 right-0'>
                <CiTrash />
            </button>
        </div>
    )
}

export default MiniCartItem